import styled from "styled-components";

const PostItContainer = styled.div<{ background: string }>`
  display: inline-block;
  min-height: 25px;
  width: 150px;
  margin-right: 4px;
  margin-bottom: 4px;
  position: relative;
  box-shadow: -1px 1px 1px -1px rgb(0 0 0 / 40%);
  background-image: linear-gradient(225deg, transparent 11px, ${(props) => props.background ?? "none" } 11px);
  cursor: move;

  &:before {
    content: "";
    position: absolute;
    display: block;
    width: 0;
    top: 0;
    right: 0;
    border-width: 0 16px 16px 0;
    border-style: solid;
    border-color: transparent transparent rgba(0, 0, 0, .1) rgba(0, 0, 0, .1);
    box-shadow: -1px 1px 1px -1px rgb(0 0 0 / 40%);
}
`;


export default PostItContainer;
